import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Booking_type } from '../models/booking_type';

@Injectable({
  providedIn: 'root'
})

export class BookingTypeService extends CrudService<Booking_type, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/booking_type`);

    this._http = _http;
  }

}

